import { AxiosResponse } from 'axios';

import { DOCUMENT_TYPE } from '../../types';
import { DOCUMENTS_SEARCH_FILTERS } from '../../types';

import { PaginationResponse } from './dto/BaseApi';
import { DocumentResponse, DocumentsResponse } from './dto/Documents';
import BaseApi from './BaseApi';

const documentsApi = {
  getDocuments(
    filters: DOCUMENTS_SEARCH_FILTERS
  ): Promise<AxiosResponse<PaginationResponse<DocumentsResponse[]>>> {
    return BaseApi.post('/api/v1/documents/search', filters);
  },

  getDocument(
    id: number,
    accountId: number,
    type: DOCUMENT_TYPE
  ): Promise<AxiosResponse<DocumentResponse>> {
    return BaseApi.get(
      `/api/v1/documents/${id}/details?accountId=${accountId}&type=${type}`
    );
  },

  getDocumentPDF(
    id: number,
    accountId: number,
    type: DOCUMENT_TYPE,
    signed: boolean
  ): Promise<AxiosResponse<ArrayBuffer>> {
    return BaseApi.get(
      `/api/v1/documents/${id}?accountId=${accountId}&type=${type}&signed=${signed}`,
      {
        headers: {
          Accept: 'application/pdf',
        },
        responseType: 'arraybuffer',
      }
    );
  },
};

export default documentsApi;
